import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\"><path d=\"M33.344 478.72h958.976v66.688H33.344z\" p-id=\"5431\" /><path d=\"M479.552 32.512h66.688v958.976H479.552z\" p-id=\"5432\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol